<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class ActivityBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) product

        get items() {
            const cityLabel = activitiesRuntimeStore.city?.id
                ? `${activitiesRuntimeStore.city.name}, ${activitiesRuntimeStore.city.countryName}`
                : ''
            const countryLabel = activitiesRuntimeStore.country?.name
            const getSearchPageLabel = () => (cityLabel ? cityLabel : countryLabel)
            const addSearchPageLink = items => {
                    items.push({
                        title: getSearchPageLabel(),
                        to: activitiesRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                },
                addInfoPageLink = items => {
                    items.push({
                        title: this.product.info?.name,
                        to: activitiesRuntimeStore.infoPageLink(this.product, this.searchRequest),
                        exact: true,
                    })
                }
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'activities':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'activity':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info?.name,
                        disabled: true,
                    })
                    break
                case 'activityBooking':
                    addSearchPageLink(items)
                    addInfoPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'activityConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info?.name,
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(ActivityBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
